import { FlightplanId } from "@poscon/shared-types";
import { EdstFpData, EramMessageElement } from "@poscon/shared-types/eram";
import type { RootThunkAction } from "../store";
import { eramHubConnection } from "~/eramHubConnection";
import { edstFpSelector, updateEdstFlightplan } from "../slices/edstFlightplanSlice";

import { processEramMessage as processMessage } from "@poscon/shared-frontend";

export const processEramMessage = (
  message: EramMessageElement[],
  sentFromGraphicalMenu = true,
): RootThunkAction<Promise<boolean>> => {
  return async (dispatch) => {
    return await dispatch(processMessage(message, "EDST", sentFromGraphicalMenu));
  }
}

export const updateEdstFpData = (fpId: FlightplanId, data: Partial<EdstFpData>): RootThunkAction => {
  return (dispatch, getState) => {
    const prevData = edstFpSelector(getState(), fpId);
    dispatch(updateEdstFlightplan({ fpId, data: { ...prevData, ...data } }));
    eramHubConnection.emit("updateEdstFp", fpId, data);
  };
};
